import { useDataGridContext } from '@cmg/data-grid';
import { Link, Stack, Typography } from '@cmg/design-system';
import { useCallback } from 'react';

export const FilteredGridNoRowOverlay: React.FC = () => {
  const { setFilters } = useDataGridContext();

  const handleResetFilters = useCallback(() => {
    setFilters(null);
  }, [setFilters]);

  return (
    <Stack alignItems="center" spacing={1} marginTop={4}>
      <Typography variant="h3">No Results Found</Typography>
      <Typography color="text.secondary">
        Try adjusting your filters to view more results or{' '}
        <Link
          className="ag-overlay-button"
          sx={{ pointerEvents: 'all' }}
          onClick={handleResetFilters}
        >
          reset filters
        </Link>{' '}
        to see all data
      </Typography>
    </Stack>
  );
};
